export default "__VITE_ASSET__CTgOkOPK__"